// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jn-0";
export var discountCodeInput = "_jn-1";